import { InjectionToken } from '@angular/core';

export const LOCAL_STORAGE = new InjectionToken<string>('LOCAL_STORAGE');



// WEBPACK FOOTER //
// ./src/modules/local-storage/local-storage.ts